import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import authState from '@/store/auth';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect:'/signin',
  },
  {
    path: '/signin',
    name: 'Signin',
    component: () => import('../views/Signin.vue')
  },
  {
    path: '/construction',
    name: 'ConstructionList',
    component: () => import('../views/construction/ConstructionSearch.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/construction/registration',
    name: 'ConstructionRegistration',
    component: () => import('../views/construction/ConstructionRegister.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/construction/constructionedit/:id',
    name: 'ConstructionEdit',
    component: () => import('../views/construction/ConstructionEdit.vue')
  },
  {
    path: '/sales/list',
    name: 'SalesList',
    component: () => import('../views/sales/SalesList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

// 未認証の場合はログイン画面へ
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth) {
    if (authState.isLogin) {
      // 認証済み
      next();
    } else {
      // ログイン前に認証が必要なページにアクセスした場合は、ログイン後に遷移するようリダイレクト指定
      next({ name: 'Signin', query: { redirect: to.fullPath } });
    }
  } else {
    next();
  }
});

export default router;
